'use client';

import { IconDynamic } from '@/components';
import { cn } from '@/libs';

type ArrowSize = 'sm' | 'md' | 'lg' | 'xl';

type MustangArrowProps = {
  size?: ArrowSize;
  className?: string;
};

const ARROW_SIZES = {
  sm: {
    width: 35,
    height: 18,
    arrowWidth: 14,
    spacing: 11,
  },
  md: {
    width: 40,
    height: 24,
    arrowWidth: 18,
    spacing: 14,
  },
  lg: {
    width: 50,
    height: 30,
    arrowWidth: 22,
    spacing: 18,
  },
  xl: {
    width: 60,
    height: 36,
    arrowWidth: 26,
    spacing: 22,
  },
} as const;

export const MustangArrow = ({ size = 'md', className }: MustangArrowProps) => {
  const { width, height, arrowWidth, spacing } = ARROW_SIZES[size];

  return (
    <div
      className={cn('arrow-cycle', className)}
      style={{
        width: `${width}px`,
        height: `${height}px`,
      }}
    >
      {IconDynamic('MustangArrow', {
        className: 'arrow a1',
        width: arrowWidth,
        height,
      })}
      {IconDynamic('MustangArrow', {
        className: 'arrow a2',
        width: arrowWidth,
        height,
        style: { left: `${spacing}px` },
      })}
      {IconDynamic('MustangArrow', {
        className: 'arrow a3',
        width: arrowWidth,
        height,
        style: { left: `${spacing * 2}px` },
      })}
    </div>
  );
};
